/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PaymentMethodType {
    CARD = 'card',
    US_BANK_ACCOUNT = 'us_bank_account',
}
